import React, { useEffect, useState } from 'react'
import axios from 'axios'
import socket from '../Components/socket'
import { apiRequest } from '../../apiService/allApi'

const Referralhis = () => {
  const [user, setUser] = useState()
  const [isLoading, setIsLoading] = useState(false)

  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {

    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++ 

  const role = async () => {
    socket.emit('getprofile')

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    // await axios
    // .get(baseUrl+`me`, { headers })

    const res = await apiRequest(`me`, "GET", null, headers)
    // .then(res => {
    setUser(res.data)

    Allgames(res.data.referral_code)
    // window.location.reload()
    // })
  }

  const [cardData, setGame] = useState([])
  // console.log(cardData)

  const Allgames = async id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    setIsLoading(true)
    // await axios
    //   .get(baseUrl+`referral/code/winn/${id}`, {
    //     headers
    //   })

    const res = await apiRequest(`referral/code/winn/${id}`, "GET", null, headers)
    // .then(res => {
    setGame(res.data)
    // console.log(res.data);
    setIsLoading(false)
    // })
  }

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };


  useEffect(() => {
    role()
    //eslint-disable-next-line
  }, [])

  if (cardData == undefined) {
    return null
  }

  return (
    <div>

      <div className="">

        <div>

          {isLoading ? (

            /* =========================================
               LOADING
            ========================================= */

            <div className="prince_game_loading">

              <div
                className="prince_game_loader_box"
                style={{ zIndex: "99" }}
              >
                <img
                  src="/images/LandingPage_img/loader1.gif"
                  alt="Loading"
                />
              </div>

            </div>

          ) : cardData && cardData?.length == 0 ? (

            /* =========================================
               EMPTY
            ========================================= */

            <div className="prince_game_empty">

              <img
                src="./images/not-found.gif"
                alt="no data"
              />

              <div className="prince_game_empty_text">

                <h3>
                  No Referral History
                </h3>

                <p>
                  You have no referral history yet.
                </p>

              </div>

            </div>

          ) : (

            cardData &&
            cardData.map(card => {

              return (

                <div
                  className="prince_game_history_card"
                  key={card?._id}
                >

                  {/* =========================================
                  HEADER
              ========================================= */}

                  <div className="prince_game_status_banner prince_game_status_win">

                    <span className="prince_game_status_dot"></span>

                    <b className="prince_game_status_text">
                      REFERRAL EARNING
                    </b>

                  </div>


                  {/* =========================================
                  BODY
              ========================================= */}

                  <div className="prince_game_history_body">


                    {/* =====================================
                    LEFT SIDE
                ===================================== */}

                    <div className="prince_game_history_left">

                      <div className="prince_game_history_item">

                        <span className="prince_game_history_label">
                          EARNED FROM
                        </span>

                        <strong className="prince_game_room">
                          {card?.earned_from?.Name}
                        </strong>

                      </div>

                    </div>


                    {/* =====================================
                    RIGHT SIDE
                ===================================== */}

                    <div className="prince_game_history_right">

                      {/* AMOUNT */}

                      <div className="prince_game_history_item">

                        <span className="prince_game_history_label">
                          EARNING AMOUNT
                        </span>

                        <strong className="prince_referral_amount">
                          +₹{card?.amount}
                        </strong>

                      </div>


                      {/* CLOSING BALANCE */}

                      <div className="prince_game_history_item">

                        <span className="prince_game_history_label">
                          CLOSING BALANCE
                        </span>

                        <strong className="prince_game_closing_balance">
                          {card?.closing_balance.toFixed(2)}
                        </strong>

                      </div>

                    </div>

                  </div>


                  {/* =========================================
                  FOOTER
              ========================================= */}

                  <div className="prince_game_history_footer">

                    <div className="prince_game_date">

                      <span className="prince_game_date_icon">
                        📅
                      </span>

                      <span>
                        {dateFormat(card?.createdAt).split(",")[0]}
                      </span>

                    </div>


                    <span className="prince_game_time">

                      @
                      {dateFormat(card?.createdAt).split(",")[1]}

                    </span>

                  </div>

                </div>

              );

            })

          )}

        </div>

      </div>

    </div>
  )
}

export default Referralhis
